import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ContentNotFound from 'rebook/apps/base/components/ContentNotFound';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';


class Error404 extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.SeoActions.setData({
      title: `Title: 404 - страница не найдена. Перейдите на главную страницу и читайте более ` +
        `${this.props.booksPerSubscriptionCounter.total} книг по подписке на iPhone, iPad, Android`,
    });
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  render() {
    return (
      <ContentNotFound />
    );
  }
}

function mapStateToProps(state) {
  return {
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Error404);
